// import moment from 'moment'
import PageNavBackLayoutCpt from '@/components/page/PageNavBackLayoutCpt';
import ListViewCpt from '@/components/list/ListViewCpt';
import { rqtPostListAppointmentApplyPage } from '@/services/wms/appointment';
export default {
  components: {
    PageNavBackLayoutCpt,
    ListViewCpt
  },
  data() {
    return {
      listRequest: rqtPostListAppointmentApplyPage
      // getConfirm: this.$message.warning('募集时间还未结束！')
    };
  },

  /* computed: {
    getConfirm () {
      return this.$message.warning('募集时间还未结束！')
    }
  }, */
  methods: {
    alertWindow(item) {
      console.log('----', item.productAppointmentStatus);
      // if(item.productAppointmentStatus !== '02') {
      //   this.$message.warning('募集时间还未开始！')
      // }
    }
  }
};